<template>
  <header v-if="currentOutcome" class="current-outcome-title" data-test="pw-header">
    <div class="outcome-title-text">
      <div
        class="outcome-title-header"
        v-html="cms.asHtml(props.currentOutcome?.full_title)"
        data-test="pw-outcome-title"
      ></div>
      <div
        class="outcome-title-desc"
        v-html="cms.asHtml(props.currentOutcome?.brief_description)"
        data-test="pw-outcome-desc"
      ></div>
    </div>
    <div class="outcome-image-container">
      <img
        :src="props.currentOutcome?.image?.url"
        :alt="cms.asText(props.currentOutcome?.name)"
        class="outcome-image"
        data-test="pw-outcome-img"
      />
    </div>
  </header>
</template>

<script setup lang="ts">
import { CmsGoalData } from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";

const props = defineProps<{ currentOutcome: Partial<CmsGoalData> | null }>();
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables";

.current-outcome-title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @light-gray;
  align-items: flex-start;
  max-width: 1170px;
  padding: 2rem 0 0;

  @media (max-width: 1023px) {
    display: none;
  }
}

.outcome-title-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
}

.outcome-image-container {
  max-width: 120px;
  aspect-ratio: 1 / 1;
  align-self: center;
}

.outcome-image {
  width: 100%;
  aspect-ratio: 1 / 1;
}
</style>
